import styled from 'styled-components';

import { BodySmallMedium, BodyStandardRegular, Colour } from '@xemplo/style-constants';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const Description = styled.div`
  ${BodyStandardRegular};
  color: ${Colour.Gray[600]};
  && {
    white-space: normal;
  }
`;

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Label = styled.div`
  ${BodySmallMedium};
  color: ${Colour.Gray[700]};
`;

export const OptionalText = styled.span`
  color: ${Colour.Gray[300]};
`;
